import { render } from "./App.vue?vue&type=template&id=a20880d6&scoped=true&bindings={}"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=a20880d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a20880d6"

export default script